import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit  {
  title = 'ycc-forms';
  constructor(private router: Router) { }
  
  ngOnInit() {
    this.router.events.subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
            return;
        }
        window.scrollTo(0, 0)
    });
    //this.browserCheck();
}

public browserCheck () {
  console.log('Browser: ' + navigator.userAgent);
  console.log('Document Mode: ' + window.document['documentMode']);
 // if ( navigator.userAgent.toLowerCase().indexOf('chrome') > -1 && navigator.userAgent.toLowerCase().indexOf('edge') == -1) {
   if ( navigator.userAgent.toLowerCase().indexOf('chrome') > -1 ) {
    return true;
  } else {
    alert ('The browser you are using is not supported. Please use Chrome to open this application. Thank you.');
    this.router.navigate(['/error'], { queryParams: { code: 'error' } });
  }
}
}
